import { ModalProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { Button } from '@/components/ui/button'
import { BaseModal } from '@/components/shared/baseModal'

export function Modal({ children, onClose, title }: ModalProps) {
  return (
    <BaseModal onClose={onClose} title={title}>
      <div>
        <div className='space-y-2'>{children}</div>
        <div className='mt-4 flex justify-center'>
          <Button onClick={onClose} aria-label='Close modal' size='xl'>
            OK
          </Button>
        </div>
      </div>
    </BaseModal>
  )
}
